var App = App || {};

App.SharedSmartAppBanner = (function ($) {
    'use strict';

    function init() {
        var alerts = $(".vc-site-alerts");
        var header = $(".vc-site-header");
        var offcanvasNavigation = $("#offcanvasNavigation");

        new SmartBanner({
            daysHidden: 15,
            daysReminder: 90,
            appStoreLanguage: "us",
            title: "The Bank of Missouri",
            author: "The Bank of Missouri",
            button: "View",
            store: {
                ios: "On the App Store",
                android: "In Google Play"
            },
            price: {
                ios: "FREE",
                android: "FREE"
            }
        });

        var $smartbanner = $(".smartbanner"),
            $smartbannerButton = $smartbanner.find(".smartbanner-button"),
            $smartbannerClose = $smartbanner.find(".smartbanner-close"),
            $smartbannerContainer = $(".smartbanner-container");

        $smartbanner.prependTo("header.vc-site-header.d-lg-none");

        $smartbannerButton
            .addClass("btn btn-sm btn-primary")
            .removeClass("smartbanner-button")
            .children("span")
            .removeClass("smartbanner-button-text");

        $smartbannerContainer.addClass("container");

        $smartbannerClose.on("click", function () {
            var offset = $(header).outerHeight();

            if (alerts.length) {
                offset += $(alerts).outerHeight();
            }

            $(offcanvasNavigation).css("top", offset);
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SharedSmartAppBanner.init();
});